import { render, staticRenderFns } from "./InputGroupButtonToolbar.vue?vue&type=template&id=79e4c3ee"
import script from "./InputGroupButtonToolbar.vue?vue&type=script&lang=js"
export * from "./InputGroupButtonToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports